import classNames from "classnames";

import { GoogleLogin } from "@react-oauth/google";

import { GoogleIcon, MicrosoftIcon, Stack } from "Components/UI";

import styles from "./SocialLogins.module.css";

export default function SocialMedialLogins({
    loading,
    setLoading,
    onGoogleSuccess,
    onMicrosoftClick,
}) {
    return (
        <Stack direction="row" gap={2}>
            <div
                className={classNames(styles.button, styles.outlined, styles.grow, styles.growGoogle, {
                    [styles.disabled]: loading,
                })}
            >
                <span className={styles.inner}>
                    <span className={styles.iconBox}>
                        <GoogleIcon className={styles.icon} />
                    </span>
                    <span className={styles.label}>Google</span>
                </span>

                <GoogleLogin
                    text="signin"
                    onSuccess={(credentialResponse) => {
                        setLoading(true);
                        onGoogleSuccess?.(credentialResponse);
                    }}
                    onError={() => {
                        console.log("Google Login Failed");
                        setLoading(false);
                    }}
                    auto_select={true}
                    containerProps={{ className: styles.googleOverlay }}
                />
            </div>

            <button
                className={classNames(styles.button, styles.bordered, styles.grow, styles.growMicrosoft, {
                    [styles.disabled]: loading,
                })}
                disabled={loading}
                onClick={() => {
                    if (loading) return;
                    onMicrosoftClick?.();
                }}
                type="button"
            >
                <span className={classNames(styles.inner, styles.innerMs)}>
                    <span className={styles.iconBoxMs}>
                        <MicrosoftIcon className={styles.icon} />
                    </span>
                    <span className={styles.label}>Microsoft</span>
                </span>
            </button>
        </Stack>
    );
}
